import axios from 'axios'
import store from '@/store'
import { ElMessage, ElMessageBox } from 'element-plus'

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 40000
})

// 请求拦截器
service.interceptors.request.use(
  (config) => {
    // 在这个位置需要统一的去注入token
    if (store.getters.token) {
      // 如果token存在 注入token
      config.headers.Authorization = `Bearer ${store.getters.token}`
    }

    return config // 必须返回配置
  },
  (error) => {
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  (response) => {
    // 请求正确业务错误
    if (response.data.code >= 400 || response.data.code < 100) {
      if (response.data.code === 401) {
        // token超时
        store.dispatch('user/logout')
        ElMessage.error('令牌过期')
        return Promise.reject(response.data.message)
      }
      if (response.data.code === 520) {
        ElMessageBox.alert(
          '<div>1. 请去后台公众号管理区刷新token</div><div>2. 请检查公众号配置appid以及appSecret等数据是否正确</div><div>2. 请检查公众号配置appid以及appSecret等数据是否正确</div>',
          '后台配置错误',
          {
            confirmButtonText: '确认',
            dangerouslyUseHTMLString: true
          }
        )
        return Promise.reject(response.data.message)
      }

      ElMessage.error(response.data.message)
      return Promise.reject(response.data.message)
    }

    if (response.config.url !== '/sys/oauth/token') {
      const { message, data, code } = response.data
      //   要根据success的成功与否决定下面的操作
      if (message === 'success' || code === '200') {
        return data
      } else {
        // 业务错误
        ElMessage.error(message) // 提示错误消息
        return Promise.reject(new Error(message))
      }
    }
    return response.data
  },
  (error) => {
    const message = error.response?.data?.message || '请求出错'

    if (error.response.data.code === 401) {
      // token超时
      store.dispatch('user/logout')
      ElMessage.error('令牌过期')
      return Promise.reject(message)
    }
    ElMessage.error(message) // 提示错误信息
    return Promise.reject(message)
  }
)

export default service
